import { alpha, Box, useTheme } from "@mui/material";
import {
	TreeItem2Content,
	TreeItem2IconContainer,
	TreeItem2GroupTransition,
	TreeItem2Label,
	TreeItem2Root,
	useTreeItem2,
} from "@mui/x-tree-view";
import clsx from "clsx";
import { TreeItem2Icon } from "@mui/x-tree-view/TreeItem2Icon";
import { TreeItem2Provider } from "@mui/x-tree-view/TreeItem2Provider";
import { forwardRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomMenu from "../../customMenu";
import scrollClicker from "../../../../utils/scrollClicker";

const CustomTreeItem = forwardRef(function CustomTreeItem(props, ref) {
	const {
		id,
		itemId,
		label,
		link,
		icon,
		children,
		disabled,
		hideTitle = false,
		open = true,
		closeOnClickItem = false,
		setOpen = () => { },
		setSelectedItems = () => { },
		setExpandedItems = () => { },
		selectedItems = [],
		paternal = null,
		nodes = null,
		apiRef,
		titlePage = "",
		setTitlePage = () => { },
		...other //
	} = props;
	const theme = useTheme();
	const {
		getRootProps,
		getContentProps,
		getIconContainerProps,
		//getCheckboxProps,
		getLabelProps,
		getGroupTransitionProps,
		status,
	} = useTreeItem2({ id, itemId, children, label, disabled, rootRef: ref });
	const navigate = useNavigate();
	const [anchorEl, setAnchorEl] = useState(null);
	const openMenu = Boolean(anchorEl);

	useEffect(() => {
		let pageName = window.location.pathname;
		pageName = pageName.startsWith("/mirror")
			? pageName.replace("/mirror", "")
			: pageName;

		if (nodes?.some((item) => item.link === pageName || pageName?.includes(item.link))) {
			// adiciona o próprio item como expandido
			setExpandedItems((old) => [...new Set([...old, itemId])]);
		} else if (link === pageName) {
			setSelectedItems(paternal ? [paternal.itemId, itemId] : [itemId]);

			// adiciona o pai, se existir, sem remover outros expandidos
			setExpandedItems((old) =>
				paternal ? [...new Set([...old, paternal.itemId])] : old
			);

			setTitlePage(hideTitle ? "" : label);
		} else if (pageName?.includes(link)) {
			setSelectedItems(paternal ? [paternal.itemId, itemId] : [itemId]);

			setExpandedItems((old) =>
				paternal ? [...new Set([...old, paternal.itemId])] : old
			);

			setTitlePage(hideTitle ? "" : label);
		}
	}, [window.location.pathname, open]);

	const handleItemClick = (e) => {
		if (nodes && !paternal) {
			// se for um item pai -> alterna abre/fecha
			setExpandedItems(
				(oldIds) =>
					oldIds.includes(itemId)
						? oldIds.filter((id) => id !== itemId) // recolhe se já estava expandido
						: [...oldIds, itemId] // adiciona sem perder os outros
			);
		} else {
			// se for item sem filhos
			if (open) {
				setExpandedItems((oldIds) =>
					paternal
						? [...new Set([...oldIds, paternal.itemId])] // adiciona o pai
						: oldIds
				);
			}

			setSelectedItems(paternal ? [itemId, paternal.itemId] : [itemId]);

			if (link) {
				if (closeOnClickItem) setOpen(false);
				
				let finalLink = link;
				const isMirrorPath = window.location.pathname.includes("mirror");
				if (isMirrorPath && !link.startsWith("/mirror")) {
					finalLink = `/mirror${link}`;
				}
				
				navigate(finalLink);
				setTitlePage(hideTitle ? "" : label);
			}
		}
	};

	const styles = {
		content: {
			display: "flex",
			marginY: "3px",
			marginX: 0,
			minHeight: "40px",
			height: "auto",
			color:
				status.selected && !!paternal
					? theme?.palette?.white?.main
					: status?.selected
						? theme?.palette?.white?.main
						: status.expanded
							? theme?.palette?.white?.main
							: theme?.palette?.sideBar?.textDisabled,

			background:
				status.selected && !!paternal
					? theme.palette.gradient.buttonSelected //cor para o node filho que estiver selecionado
					: status.selected
						? alpha(theme?.palette?.colors?.white.lighter, 0.1)
						: null,
			"&:hover": {
				background:
					status.selected && !paternal
						? `linear-gradient(90deg, ${alpha(
							theme.palette.buttonHoverGradient.dark,
							0.05
						)} 0%, ${alpha(
							theme.palette.buttonHoverGradient.light,
							0.05
						)} 100%)`
						: `linear-gradient(90deg, ${alpha(
							theme.palette.buttonHoverGradient.dark,
							0.5
						)} 0%, ${alpha(
							theme.palette.buttonHoverGradient.light,
							0.5
						)} 100%)`,
			},
			borderRadius: "20px",
		},

		contentBox: {
			flexGrow: 1,
			display: "flex",
			gap: "10px",
			width: "100%",
			justifyContent: "center",
			alignItems: "center",
		},
		groupTransition: {
			marginLeft: 2,
			borderLeft: `1px solid ${theme?.palette?.white.main}`,
		},
	};
	return (
		<>
			<TreeItem2Provider itemId={itemId}>
				<TreeItem2Root {...getRootProps(other)}>
					<TreeItem2Content
						{...getContentProps({
							className: clsx("content", {
								expanded: status.expanded,
								selected: status.selected,
								focused: status.focused,
							}),
						})}
						sx={styles.content}
						onClick={handleItemClick}
						onMouseDown={(e) => scrollClicker(e, nodes, link)}
						onMouseEnter={(e) => {
							setAnchorEl(e.currentTarget);
						}}
						onMouseLeave={(e) => {
							setAnchorEl(null);
							apiRef?.current?.focusItem(e, selectedItems[0]);
						}}
					>
						<Box sx={styles.contentBox}>
							{icon}
							{open ? <TreeItem2Label {...getLabelProps()} /> : null}
						</Box>
						{open && (
							<TreeItem2IconContainer {...getIconContainerProps()}>
								<TreeItem2Icon status={status} />
							</TreeItem2IconContainer>
						)}
						<CustomMenu
							anchorEl={anchorEl}
							openMenu={openMenu && !open}
							setAnchorEl={setAnchorEl}
							{...props}
						/>
					</TreeItem2Content>
					{children && open && (
						<TreeItem2GroupTransition
							{...getGroupTransitionProps()}
							sx={styles.groupTransition}
						/>
					)}
				</TreeItem2Root>
			</TreeItem2Provider>
		</>
	);
});
export default CustomTreeItem;
